import {createPortal} from 'react-dom'
import {MergeBoxPanelContent} from '@github-ui/mergebox'
import type {Channels} from '@github-ui/mergebox/use-mergeability-live-updates'
import {ssrSafeDocument} from '@github-ui/ssr-utils'
import {useDockedPanel} from '../../contexts/DockedPanelContext'
import {DOCKED_SIDE_PANEL_CONTENT_ID} from './DockedSidePanel'
import {Panel} from './Panel'

interface MergeStatusSidePanelProps {
  helpUrl: string
  viewerLogin: string
  channels: Channels
}

/**
 * Renders the merge box in the docked side panel via portal.
 *
 * Only used when the docked panel system is active (files-changed route with
 * the `prs_docked_side_panel` feature flag enabled). The existing Dialog
 * sidesheet in `MergeabilitySidesheet` handles non-docked routes.
 */
export function MergeStatusSidePanel({helpUrl, viewerLogin, channels}: MergeStatusSidePanelProps) {
  const panelName = useDockedPanel()
  const isOpen = panelName === 'mergeStatus'

  const sidePanelContent = isOpen ? ssrSafeDocument?.getElementById(DOCKED_SIDE_PANEL_CONTENT_ID) : null

  if (!isOpen || !sidePanelContent) return null

  return createPortal(
    <Panel panelName="mergeStatus">
      <Panel.Body className="p-0">
        <MergeBoxPanelContent helpUrl={helpUrl} viewerLogin={viewerLogin} channels={channels} />
      </Panel.Body>
    </Panel>,
    sidePanelContent,
  )
}
